import { gql, TypedDocumentNode } from '@common/hooks';
import { SimpleFileFragmentType } from '@common/graphql';

export type ApprovalsChainByIdResponse = {
  approvalChainById: {
    id: string;
    approvalDocument: SimpleFileFragmentType;
    currentStep?: {
      id: string;
    };
    currentApprovers: {
      id: string;
      worksMembership: {
        id: string;
        name: string;
      };
    }[];
  };
};

export type ApprovalsChainByIdVariables = {
  id: string;
};

export const ApprovalsChainByIdQuery: TypedDocumentNode<
  ApprovalsChainByIdResponse,
  ApprovalsChainByIdVariables
> = gql`
  query approvalChainById($id: ID!) {
    approvalChainById(id: $id) {
      id
      approvalDocument {
        id
        createdAt
        downloadUrl
        filename
        previewUrl
      }
      currentStep {
        id
      }
      currentApprovers {
        id
        worksMembership {
          id
          name
        }
      }
    }
  }
`;
